export default __webpack_public_path__ + "static/media/active.27320ff9.svg";